<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-07-21 10:05:41
 * @LastEditors: zml
 * @LastEditTime: 2026-07-02 10:56:22
-->
<template>
  <div class="foot-container">
    <div class="footer-vessel">
      <div class="footer-touch-us" v-if="isshowfootemeun">
        <div class="touch-us container">
          <div
            class="touch_title"
          >{{ $hs('您可以发送电子邮件与我们取得联系', 'You can send an email Get in touch with us','Puede enviar un correo electrónico póngase en contacto con nosotros')}}</div>
          <div class="input_new">
            <input type="text" class="_input" :placeholder="$hs('你的电子邮箱','Your Eamil','Su correo electrónico')" v-model="email" />
            <div class="subsribe" @click="submitSubsrcibe">{{ $hs('提交', 'Subsribe','Subsribe')}}</div>
          </div>
        </div>
      </div>
      <div class="footer-touch-list">
        <div class="footer-image-left">
          <img src="../assets/LLH_follow/footer-left.png" />
        </div>
        <div class="footer-container-content container">
          <img :src="getSetting.logo" style="height: 160px;"/>
          <div class="container-content">
            <div class="content1">
              <div style="margin-bottom: 20px;font-weight: 700;">{{ $hs('联系我们', 'Contact','Contacto contacto')}}</div>
              <div
                style="margin-bottom: 20px;"
              >{{ $hs(getSetting.title,getSetting.enTitle,getSetting.rusTitle) }}</div>
              <div style="margin-bottom: 20px;width: 400px;word-wrap: break-word;">{{ getSetting.enAddress }}</div>
            </div>
            <div class="content2">
              <div style="margin-bottom: 20px;font-weight: 700;">{{ $hs('关注我们', 'Follow Us','Nos sigue')}}</div>
              <div class="content2-images">
                <img src="../assets/LLH_follow/in.png" alt />
                <img src="../assets/LLH_follow/f.png" alt />
                <img src="../assets/LLH_follow/You.png" alt />
                <img src="../assets/LLH_follow/niao.png" alt />
                <img src="../assets/LLH_follow/photo.png" alt />
              </div>
            </div>
            <div class="content3">
              <div
                style="margin-bottom: 20px;"
                @click="typeRap('home')"
                :class="topath=='/home'?'contentActive':''"
              >{{ $hs('首页', 'HOME','En la primera página')}}</div>
              <div
                style="margin-bottom: 20px;"
                @click="typeRap('product')"
                :class="topath=='/product'?'contentActive':''"
              >{{ $hs('类别', 'CATEGORY','productos')}}</div>
              <div
                style="margin-bottom: 20px;"
                @click="typeRap('about')"
                :class="topath=='/about'?'contentActive':''"
              >{{ $hs('关于我们', 'ABOUT','Acerca de nosotros')}}</div>
              <div
                style="margin-bottom: 20px;"
                @click="typeRap('news')"
                :class="topath=='/news'?'contentActive':''"
              >{{ $hs('博客/新闻', 'BLOG','El BLOG')}}</div>
              <div
                style="margin-bottom: 20px;"
                @click="typeRap('contact')"
                :class="topath=='/contact'?'contentActive':''"
              >{{ $hs('联系我们', 'CONTACT US','Contacta con nosotros')}}</div>
            </div>
          </div>
          <div class="biaozhu">{{ $hs(getSetting.copyRight, getSetting.enCopyRight,getSetting.rusCopyRight)}}</div>
        </div>
        <div class="footer-image-right">
          <img src="../assets/LLH_follow/footer-right.png" />
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapState, mapGetters } from 'vuex'
import loginModal from '@/components/memberModal/loginModal.vue'
import registerModel from '@/components/memberModal/registerModel.vue'
import { Message } from '@/api/login'

export default {
  components: {
    loginModal,
    registerModel
  },
  data() {
    return {
      isshowfootemeun: true,
      email: "",
      topath: ""
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapGetters('setting', {
      getSetting: 'get_setting',
      getLanguageConfig: 'get_language_config'
    }),
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    })
  },
  watch: {
    '$route': {
      handler(to, from) {
        {
          this.topath = to.path;
          if (to.path === '/home') {
            this.isshowfootemeun = true
          } else {
            this.isshowfootemeun = false
          }
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    }
  },
  methods: {
    // 登录
    login() {
      this.$refs.loginModal.open()
    },
    getScrollTop() {
      localStorage.setItem('scrollTop', JSON.stringify(0))
    },
    typeRap(typeLin) {
      this.getScrollTop();
      if (typeLin == 'about') {
        this.$router.push('/about');
      } else if (typeLin == 'news') {
        this.$router.push('/news')
      } else if (typeLin == 'contact') {
        this.$router.push('/contact')
      } else if (typeLin == 'home') {
        this.$router.push('/home')
      } else if (typeLin == 'product') {
        this.$router.push('/product')
      }
    },
    submitSubsrcibe() {
      if (!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))) {
        this.$message.error(this.$hs('请输入正确的邮箱', 'Please enter the correct email address', 'Por favor, introduzca un correo electrónico correcto'))
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t('NT.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Message({ email: this.email })
        .then(res => {
          if (res.success) {
            this.$message.success(this.$hs('提交成功', 'Submitted successfully', 'Presentación exitosa'))
            this.email = ''
          } else {
            this.$message.error(this.$hs('提交失败', 'Submission failed', 'Presentación fallida'))
          }
        })
        .catch(err => {
          this.$message.error(JSON.stringify(err))
        })
        .finally(() => {
          loading.close()
        })
    },
    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    goPersonal() {
      if (this.userInfo.id) {
        this.$router.push('/personal')
      } else {
        this.login()
      }
    },
  }
}
</script>
  <style lang="scss" scoped>
.footer-vessel {
  width: 100%;
  height: 100%;
  .footer-touch-us {
    height: 136px;
    width: 100%;
    background: #313131;
    .touch-us {
      margin: 0 auto;
      line-height: 136px;
      color: #fff;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .touch_title {
      width: 500px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
    .input_new {
      display: flex;
      align-items: center;
    }
    ._input {
      width: 500px;
      height: 56px;
      background: #ffffff;
      border-radius: 10px;
      outline: none;
      font-size: 24px;
      padding: 0 20px;
    }
    .subsribe {
      width: 124px;
      height: 59px;
      text-align: center;
      line-height: 59px;
      font-size: 20px;
      background: #e33c0b;
      border-radius: 10px;
      margin-left: -15px;
      cursor: pointer;
    }
  }
  .footer-touch-list {
    background: #490d59;
    display: flex;
    position: relative;
    height:490px;
    .footer-image-left{
      position: absolute;
      left: 0;
    }
    .footer-image-right{
      position: absolute;
      right: 0;
    }

    .footer-container-content {
      margin-top: 60px;
      z-index: 111;
      
      .container-content {
        color: #fff;
        display: flex;
        .content1 {
          width: 443px;
        }
        .content2 {
          width: 243px;
          .content2-images {
            img {
              margin: 0 3px;
            }
            width: 150px;
          }
        }
        .content3 {
          width: 263px;
          font-weight: 700;
          cursor: pointer;
          > div:hover {
            color: rgb(241, 35, 35);
          }
          .contentActive {
            color: rgb(241, 35, 35);
          }
        }
      }
      .biaozhu {
        position: absolute;
        bottom: 20px;
        color: #fff;
      }
    }
  }
}
.footer-box {
  background: #fff;
  width: 100%;
  min-height: 186px;
  // max-height: 300px;
  .footer-info {
    width: 100%;
    display: flex;
    padding: 60px 0 20px 0;
    min-height: 136px;
    max-height: 250px;
    .left {
      width: 260px;

      .title {
        color: #222222;
        font-size: 18px;
        padding: 0 0 20px;
        border-bottom: 1px solid #00923f;
      }

      .web-nav {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        color: #8c9095;
        .nav {
          width: 50%;
          margin: 20px 0 0 0;
          overflow: hidden; /* 确保超出的内容被裁剪 */
          white-space: nowrap; /* 确保文本在一行内显示 */
          text-overflow: ellipsis; /* 使用省略号表示超出的文本 */
          &:hover {
            cursor: pointer;
            color: #00923f;
          }
        }
        .active {
          color: #00923f;
        }
      }
    }
    .center {
      flex: 1;
      margin: 0 60px;
      .title {
        color: #222222;
        font-size: 18px;
        padding: 0 0 20px;
        border-bottom: 1px solid #00923f;
      }

      .info-box {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        color: #8c9095;
        .cell {
          width: 50%;
          margin: 20px 0 0 0;
        }
      }

      .address-box {
        display: flex;
        font-size: 14px;
        margin: 20px 0 0 0;
        color: #8c9095;
        .address {
          line-height: 20px;
        }
      }
    }
    .right {
      width: 180px;
      .title {
        color: #222222;
        font-size: 18px;
        padding: 0 0 20px;
        border-bottom: 1px solid #00923f;
      }
    }

    .follow {
      display: flex;
      flex-wrap: wrap;
      margin: 20px 0 0 0;
      .img {
        width: 40px;
        height: 40px;
        margin: 0 6px 6px 0;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;

        // background-color: #fff;
        img {
          width: 101%;
          height: 101%;
          &:hover {
            transform: scale(1.1); //原本的图片的大小，图片原来的大小不变
            transition: all 0.5s;
          }
        }
      }
    }
  }
  .copyright {
    min-height: 50px;
    line-height: 30px;
    // text-align: center;
    font-size: 14px;
    color: #8c9095;
    padding: 0 10px 0 0;
  }
}
</style>